import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {ProductModel} from '../../../api/entity/product.model';
import {ProductConverter} from '../../../api/entity/converter/product.converter';
import {ProductDataService} from './productData.service';
@Injectable()
export class ProductDataServiceAdapter extends AbstractDataServiceDtoAdapter<ProductModel, ProductConverter> {
    constructor(dataService: ProductDataService, converter: ProductConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ProductModel {
        return new ProductModel();
    }
}
